import { Theme } from "@mui/material";
import { TFunction } from "react-i18next";
import { ChartTooltip } from "@components/Tooltip/ChartTooltip";
import { GainLossChartPercents } from "@components/Tooltip/GainLossChartPercents";

interface Props {
  yearsAgo: number;
  percent: number;
  theme: Theme;
  t: TFunction;
}

export const HistoricalQuoteTooltip = ({
  yearsAgo,
  percent,
  theme,
  t,
}: Props) => (
  <ChartTooltip theme={theme}>
    <div
      style={{ display: "flex", alignItems: "center", gap: theme.spacing(2) }}
    >
      <div
        style={{
          fontSize: theme.typography.caption.fontSize,
          lineHeight: theme.typography.caption.lineHeight,
          fontWeight: "500",
          color: theme.palette.text.onTooltipPrimary,
        }}
      >
        {t("fundamentals.year", { count: yearsAgo })}
      </div>
      <GainLossChartPercents value={percent} theme={theme} />
    </div>
  </ChartTooltip>
);
